import { generateVuexCrud, singleEntityRequest } from '@/utilities/crud/vuex';

const crud = generateVuexCrud({
    single: 'inventorySource',
});

const state = {
    ...crud.state,

    types: {
        'sftp': 'SFTP',
        'book_depot_new_arrivals': 'New Arrivals',
    },
};

const actions = {
    ...crud.actions,

    dispatchInventorySource(store, { inventorySource }) {
        return singleEntityRequest('refreshOperation', {
            method: 'post',
            url: `/api/inventorysources/${inventorySource.id}/dispatch`,
        });
    },
};

const mutations = {
    ...crud.mutations,
};

export default {
    state,
    actions,
    mutations,
};
